<template>
  <div
    @click="$emit('click')"
    class="h-10 px-2 cursor-pointer hover:bg-base-20 whitespace-nowrap"
    :class="{
      'flex items-center': middle,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    middle: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
